import { Navigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

export default function AdminRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center bg-cream-100">
        <div className="text-stone-500">Loading...</div>
      </div>
    );
  }
  if (!user || user.role !== 'admin') return <Navigate to="/admin/login" replace />;
  return children;
}
